import { Suspense, useEffect } from "react"
import { Route, Routes } from "react-router"
import { core } from "etl/core"
import { ErrorBoundary, ErrorFallback, ProtectedRoute } from "etl/features"
import { APP_ROUTER } from "./router.const";
import { FallBackSpinner } from "etl/design-system/molecules/FallBackSpinner";
import { Spinner } from "etl/design-system/atoms/Spinner";

export const App = () => {
	const { initApp } = core.useAppUseCases();
	const { appIsInitialized } = core.useEtlDataSelectors();
	const { isAuthenticated } = core.useAuthSelectors();
	const { location } = core.useNavigationSelectors();

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => void initApp(), [isAuthenticated, appIsInitialized]);

	if (!appIsInitialized) {
		return (
			<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", gap: "1rem" }}>
				<Spinner />
				<p>Initialisation de l'application...</p>
			</div>
		);
	}

	return (
		<ErrorBoundary fallback={ErrorFallback.PAGE}>
			<Routes location={location}>
				{APP_ROUTER.map(
					(route) =>
						!route.protected && (
							<Route
								key={route.path}
								path={route.path}
								element={
									<Suspense fallback={<FallBackSpinner />}>
										{route.component}
									</Suspense>
								}
							/>
						)
				)}
				{APP_ROUTER.map(
					(route) =>
						route.protected && (
							<Route
								key={route.path}
								path={route.path}
								element={
									!route.layout ? (
										<ProtectedRoute>
											<Suspense fallback={<FallBackSpinner />}>
												{route.component}
											</Suspense>
										</ProtectedRoute>
									) : (
										<div>
											<ProtectedRoute>
												<Suspense fallback={<FallBackSpinner />}>
													{route.component}
												</Suspense>
											</ProtectedRoute>
										</div>
									)
								}
							/>
						)
				)}
			</Routes>
		</ErrorBoundary>
	)
};
